export default {"src":"/_next/static/media/logoutLoan.607d8fc8.svg","height":313,"width":499,"blurWidth":0,"blurHeight":0};